import React, { useState, useRef, useEffect } from "react";
import QRCodeStyling from "qr-code-styling";
import brand_logo from "../../Assets/brand_logo.png";
import pattern1 from "../../Assets/pattern1.png";
import pattern2 from "../../Assets/pattern2.png";
import pattern3 from "../../Assets/pattern3.png";
import pattern4 from "../../Assets/pattern4.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { handleError, handleSuccess } from "../../CommonJquery/CommonJquery.js";
import { ChromePicker } from "react-color";
import { Eye, X, Upload } from "lucide-react";
// import {Modal, Tabs, Button, Tab }from "react-bootstrap/Modal";
import dummyLogo from "../../Assets/dummy-logo.svg";
import {
  server_post_data,
  custom_qr_manage,
  save_custom_qr_manage,
} from "../../ServiceConnection/serviceconnection";
import remove_uploaded_image from "../../Assets/remove_uploaded_image.png";
import "../../components/CSS/NewOnboading/Step6.css";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import Loader from "../../pages/Loader.js";

function QrCodeEdit() {
  const fileInputRef = useRef(null);
  const leftFileInputRef = useRef(null);
  const [error, setError] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [logo, setLogo] = useState();
  const [isLogoRemoved, setIsLogoRemoved] = useState(true);
  const [bussinesText, setbussinesText] = useState("");
  const [tagLine, settagLine] = useState("");

  // State for QR code styling
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState("frameBox1"); // Default to 'No Frame'
  const [image, setImage] = useState([]);
  const [logoError, setLogoError] = useState(false);
  const [businessNameError, setBusinessNameError] = useState(false);
  const [taglineError, setTaglineError] = useState(false);
  const [shakeBusiness, setShakeBusiness] = useState(false);
  const [shakeTagline, setShakeTagline] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [shareModal, setshareModal] = useState(false);
  const [size, setSize] = useState("small");

  // QR Code refs
  const modalQrCodeRef = useRef(null);
  const [color, setColor] = useState({ r: 100, g: 255, b: 0, a: 1 });
  const [styles, setStyles] = useState({
    backgroundColor: "#ec5e3a",
    textColor: "#00000",
    ctaColor: "#ff5722",
  });
  const sizeDimensions = {
    small: {
      width: 180,
      height: 180,
      description: "Tabletop QR Stand (3x3 inches)",
    },
    medium: {
      width: 300,
      height: 300,
      description: "Exit Stand Display (5x5 inches)",
    },
    large: {
      width: 600,
      height: 600,
      description: "Indoor Hoarding (10x10 inches)",
    },
  };

  // Map patterns to dot styles
  const patternToDotStyle = {
    [pattern1]: "dots",
    [pattern2]: "rounded",
    [pattern3]: "classy",
    [pattern4]: "classy-rounded",
    null: "rounded", // Default
  };
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle pattern selection
  const handlePatternSelect = (patternImage) => {
    setSelectedPattern(patternImage);
  };

  // Handle frame selection
  const handleFrameSelect = (frameClass) => {
    setSelectedFrame(frameClass);
  };

  // Custom styles for the frames in the QR display

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [textColor, setTextColor] = useState("#333");
  const [bgColor, setBgColor] = useState("#EC5E3A");
  const [URLLINK, setURLLINK] = useState("Best Shop in Town");
  const [logoweb, setLogoweb] = useState("");
  const [logonew, setLogonew] = useState("");
  const [logourl, setLogourl] = useState("");
  const [qrCodeImage, setqrCodeImage] = useState("");

  // Effect to create and update QR code when styling changes
  const qrCodeRef = useRef(null);
  const qrCodeRef2 = useRef(null);
  const qrInstance = useRef(null);

  const getFrameStyles_stsyem = () => ({
    width: "120px",
    height: "120px",
    borderRadius:
      selectedFrame === "frameBox circularFrame"
        ? "50%"
        : selectedFrame === "frameBox"
          ? "12px"
          : "0",
    overflow: "hidden",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  const getFrameStyles = () => {
    // Adjust size based on selected size option
    const dimensions = sizeDimensions["small"];

    return {
      width: `${dimensions.width}px`,
      height: `${dimensions.height}px`,
      borderRadius:
        selectedFrame === "frameBox circularFrame"
          ? "50%"
          : selectedFrame === "frameBox"
            ? "12px"
            : "0",
      overflow: "hidden",
      backgroundColor: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };
  };

  const getFrameStylesPrintMobile = () => ({
    width: "220px",
    height: "220px",
    borderRadius:
      selectedFrame === "frameBox circularFrame"
        ? "50%"
        : selectedFrame === "frameBox"
          ? "12px"
          : "0",
    overflow: "hidden",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  // Effect to create and update QR code when styling changes
  useEffect(() => {
    const createQRCode = (containerRef) => {
      if (!containerRef.current) return;
      try {
        // Clear previous content
        containerRef.current.innerHTML = "";

        // Create new QR code instance
        const currentDotStyle =
          selectedPattern !== "" ? selectedPattern : "rounded";

        if (selectedPattern === null) {
          return;
        }
        if (URLLINK === null) {
          return;
        }
        if (selectedFrame === null) {
          return;
        }
        console.log(URLLINK);
        const qrCode = new QRCodeStyling({
          width: "300",
          height: "300",
          shape:
            selectedFrame === "frameBox circularFrame" ? "circle" : "square",
          data: URLLINK,
          // image: logo && !isLogoRemoved ? logo : undefined,
          imageOptions: {
            crossOrigin: "anonymous",
            margin: 0, // ✅ No extra margin
          },
          dotsOptions: {
            type: currentDotStyle,
            color: "#000",
          },
          cornersSquareOptions: {
            type: "extra-rounded",
            color: "#000",
          },
          backgroundOptions: {
            color: "#fff",
          },
          qrOptions: {
            margin: 0, // Ensure there's no built-in padding
          },
        });

        // Append to container
        qrCode.append(containerRef.current);

        // Style the canvas and its parent container
        setTimeout(() => {
          const canvas = containerRef.current.querySelector("canvas");
          if (canvas) {
            canvas.style.width = "100%";
            canvas.style.height = "100%";

            // Apply styling to the canvas
            if (selectedFrame === "frameBox circularFrame") {
              canvas.style.borderRadius = "50%";
              canvas.style.clipPath = "circle(50% at center)";
            } else if (selectedFrame === "frameBox") {
              canvas.style.borderRadius = "12px";
              canvas.style.clipPath = "none";
            } else {
              canvas.style.borderRadius = "0";
              canvas.style.clipPath = "none";
            }
          }
        }, 100);

        return qrCode;
      } catch (err) {
        console.log(err);
        return;
      }
    };

    // Create QR code in main view
    if (qrCodeRef.current) {
      qrInstance.current = createQRCode(qrCodeRef);
    }
    // Create QR code in main view
    if (qrCodeRef2.current) {
      qrInstance.current = createQRCode(qrCodeRef2);
    }
  }, [URLLINK]);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    // fd.append("flag", "6");
    await server_post_data(custom_qr_manage, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          // console.log("Hello", final_data);
          setURLLINK(final_data.url_link_go);

          setBgColor(final_data.User_Data.application_color);
          setTextColor(final_data.User_Data.application_text_color);
          setLogonew(final_data.User_Data.website_logo);
          setbussinesText(final_data.User_Data.business_name);
          settagLine(final_data.User_Data.business_tagline);
          setSelectedFrame(final_data.User_Data.frame_name);
          setSelectedPattern(final_data.User_Data.parttan_name);
          setLogo(final_data.full_logo_url);
          setLogourl(final_data.user_linkss_link);
          setqrCodeImage(final_data.qr_image_base64);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);
  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };
  const handleShareShowClose = () => {
    // setshareModal(!shareModal);
    setshareModal(false);
  };
  // Handle logo upload
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(e.target.files[0]);
      // console.log("File Logo", file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo(e.target.result);
        setLogoweb(file);
        setLogonew("");
        setIsLogoRemoved(false);
        setLogoError(false);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add("drag-over");
  };

  // Handle drag leave
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("drag-over");
  };

  // Handle drop
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("drag-over");

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const reader = new FileReader();
      setImage(e.dataTransfer.files[0]);
      reader.onload = (e) => {
        setLogo(e.target.result);
        setLogonew("");
      };
      reader.readAsDataURL(e.dataTransfer.files[0]);
    }
  };
  const handleRemoveLogo = () => {
    setLogo(null);
    setImage(null);
    setIsLogoRemoved(true);
  };
  const validateForm = () => {
    let isValid = true;

    if (!logo || isLogoRemoved) {
      setLogoError(true);
      isValid = false;
    } else {
      setLogoError(false);
    }

    if (!bussinesText.trim()) {
      setBusinessNameError(true);
      isValid = false;
    } else {
      setBusinessNameError(false);
    }

    if (!tagLine.trim()) {
      setTaglineError(true);
      isValid = false;
    } else {
      setTaglineError(false);
    }

    return isValid;
  };

  const handleColorClick1 = (selectedColor, targetEl = null) => {
    const circles = document.querySelectorAll(".circles_color");
    circles.forEach((c) => c.classList.remove("active"));
    if (targetEl) targetEl.classList.add("active");

    const hexColor = rgbaToHex(selectedColor);

    setColor(selectedColor);
    setBgColor(hexColor);
    setStyles({
      ...styles,
      backgroundColor: hexColor,
      textColor: isLightColor(selectedColor) ? "#000000" : "#FFFFFF",
    });
  };

  const handleColorClick = (e, selectedColor) => {
    const circles = document.querySelectorAll(".circles_color");
    circles.forEach((c) => c.classList.remove("active"));
    e.currentTarget.classList.add("active");

    const hexColor = rgbaToHex(selectedColor);

    setColor(selectedColor);
    setBgColor(hexColor);
    setStyles({
      ...styles,
      backgroundColor: hexColor,
      textColor: isLightColor(selectedColor) ? "#000000" : "#FFFFFF",
    });
  };

  const isLightColor = ({ r, g, b }) => {
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  const rgbaToHex = ({ r, g, b }) => {
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  };

  const handleSave = async () => {
    try {
      setShowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("flag", "1");
      fd_from.append("image", logoweb);
      fd_from.append("old_image", logonew);
      fd_from.append("application_color", bgColor);
      fd_from.append("application_text_color", textColor);
      fd_from.append("business_name", bussinesText);
      fd_from.append("business_tagline", tagLine);
      fd_from.append("frame_name", selectedFrame);
      fd_from.append("parttan_name", selectedPattern);
      await server_post_data(save_custom_qr_manage, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            master_data_get();
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
      handleSuccess("QR Saved successfully!");
    } catch (error) {
      handleError("Error saving settings. Please try again.");
    }
  };

  const handleDownload = async (format) => {
    const qrElement = document.getElementById("qrScreenMobilePrint");

    // Ensure all images inside the qrElement are fully loaded
    const images = qrElement.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      if (!img.complete) {
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      }
      return Promise.resolve();
    });

    // Wait until all images are fully loaded
    await Promise.all(promises);

    // Small timeout to ensure styles are applied
    await new Promise((res) => setTimeout(res, 300));

    try {
      const canvas = await html2canvas(qrElement, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        scale: 1,
      });

      // Convert logo image to base64
      const logoSrc = logo; // your existing logo URL
      const logoBase64 = await convertImageToBase64(logoSrc);

      const logoImage = new Image();
      logoImage.src = logoBase64;

      logoImage.onload = () => {
        if (format === "png") {
          const ctx = canvas.getContext("2d");
          const logoWidth = 100;
          const logoHeight = 100;
          ctx.drawImage(
            logoImage,
            canvas.width - logoWidth - 10,
            canvas.height - logoHeight - 10,
            logoWidth,
            logoHeight,
          );

          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `qr_code_${size}.png`;
          link.click();
        } else if (format === "pdf") {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({ orientation: "portrait", unit: "mm" });

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const canvasRatio = canvas.height / canvas.width;
          const imgWidth = pdfWidth * 0.8;
          const imgHeight = imgWidth * canvasRatio;
          const x = (pdfWidth - imgWidth) / 2;
          const y = (pdfHeight - imgHeight) / 3;

          pdf.setFontSize(16);
          pdf.text(bussinesText, pdfWidth / 1, 20, { align: "center" });
          pdf.setFontSize(12);
          pdf.text(tagLine, pdfWidth / 1, 30, { align: "center" });
          pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
          pdf.setFontSize(10);
          pdf.text(
            `Size: ${sizeDimensions[size].description}`,
            pdfWidth / 2,
            pdfHeight - 20,
            { align: "center" },
          );

          // Add logo
          const logoWidth = 20;
          const logoHeight = 20;
          pdf.addImage(
            logoBase64,
            "PNG",
            pdfWidth - logoWidth - 10,
            pdfHeight - logoHeight - 10,
            logoWidth,
            logoHeight,
          );

          pdf.save(`qr_code_${size}.pdf`);
        }
      };

      logoImage.onerror = () => {
        console.warn("Logo failed to load, proceeding without logo");
        // fallback without logo (same as your original)
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({ orientation: "portrait", unit: "mm" });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasRatio = canvas.height / canvas.width;
        const imgWidth = pdfWidth * 0.8;
        const imgHeight = imgWidth * canvasRatio;
        const x = (pdfWidth - imgWidth) / 2;
        const y = (pdfHeight - imgHeight) / 3;

        pdf.setFontSize(16);
        pdf.text(bussinesText, pdfWidth / 2, 20, { align: "center" });
        pdf.setFontSize(12);
        pdf.text(tagLine, pdfWidth / 2, 30, { align: "center" });
        pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
        pdf.setFontSize(10);
        pdf.text(
          `Size: ${sizeDimensions[size].description}`,
          pdfWidth / 2,
          pdfHeight - 20,
          { align: "center" },
        );
        pdf.save(`qr_code_${size}.pdf`);
      };
    } catch (err) {
      console.error("Failed to generate image:", err);
    }
  };

  // 🔁 Helper to convert image to base64
  const convertImageToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = () => reject("Image load error");
        img.src = url;
      } catch (err) {
        reject(err);
      }
    });
  };

  const [updatedLogos, setUpdatedLogos] = useState(null);

  const toBase64 = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          }),
      );

  useEffect(() => {
    const loadBase64Images = async () => {
      const updatedLogos = await Promise.all(
        businessTypes2.slice(0, 3).map(async (item) => {
          try {
            const url =
              (businessImage2?.endsWith("/")
                ? businessImage2
                : businessImage2 + "/") + item.review_logo;

            const base64 = await toBase64(url);
            return { ...item, review_logo: base64 };
          } catch (e) {
            return {
              ...item,
              review_logo: "/placeholder.svg",
            };
          }
        }),
      );
      setUpdatedLogos(updatedLogos); // store it in a state variable
    };

    loadBase64Images();
  }, [businessTypes2, businessImage2]);

  const getQrInnerStyles = () => {
    const dimensions = sizeDimensions["small"];
    return {
      width: `${dimensions.width - 20}px`,
      height: `${dimensions.height - 20}px`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      borderRadius:
        selectedFrame === "frameBox circularFrame"
          ? "50%"
          : selectedFrame === "frameBox"
            ? "12px"
            : "0",
      clipPath:
        selectedFrame === "frameBox circularFrame"
          ? "circle(50% at center)"
          : "none",
      backgroundColor: "#fff",
    };
  };

  console.log("Hello Image ", businessImage2);

  const handleDownloadNew = async () => {
    setShowLoaderAdmin(true);
    const qrElement = document.getElementById("qrScreenMobilePrint");

    // Wait for all images to load
    const images = qrElement.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      if (!img.complete) {
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      }
      return Promise.resolve();
    });

    // Ensure QR code is rendered
    await Promise.all(promises);
    await new Promise((res) => setTimeout(res, 500)); // Extended delay for stability

    try {
      const canvas = await html2canvas(qrElement, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: "transparent",
        scale: 2,
        logging: true,
      });

      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "qr_code_medium.png";
      link.click();
      setShowLoaderAdmin(false);
    } catch (err) {
      console.error("Failed to generate image:", err);
    }
  };

  const [copySuccess, setCopySuccess] = useState("");
  const qrRef = useRef(null);

  // Function to copy the smart link to clipboard
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(URLLINK);
      setCopySuccess("Link copied!");
      setTimeout(() => setCopySuccess(""), 2000);
    } catch (err) {
      setCopySuccess("Failed to copy");
    }
  };

  // Function to share the smart link via Web Share API
  const handleShareLink = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Share Smart Link",
          url: URLLINK,
        });
      } catch (err) {
        console.error("Error sharing link:", err);
      }
    } else {
      handleCopyLink(); // Fallback to copying if Web Share API is not supported
    }
  };

  // Function to share the QR code
  const handleShareQR = async () => {
    try {
      // Convert QR code canvas to image data URL
      const canvas = qrRef.current.querySelector("canvas");
      const dataUrl = canvas.toDataURL("image/png");

      // Fetch the image data as a blob
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      const file = new File([blob], "qrcode.png", { type: "image/png" });

      // Use Web Share API to share the QR code image
      if (
        navigator.share &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        await navigator.share({
          title: "Share QR Code",
          files: [file],
        });
      } else {
        // Fallback: Download the QR code
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "qrcode.png";
        link.click();
      }
    } catch (err) {
      console.error("Error sharing QR code:", err);
    }
  };

  const handleShareQR2 = async () => {
    try {
      // Reference the div to capture
      const qrElement = document.getElementById("qrScreenMobilePrint");

      // Ensure all images inside the qrElement are fully loaded
      const images = qrElement.querySelectorAll("img");
      const promises = Array.from(images).map((img) => {
        if (!img.complete) {
          return new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          });
        }
        return Promise.resolve();
      });

      // Wait until all images are fully loaded
      await Promise.all(promises);

      // Small timeout to ensure styles are applied
      await new Promise((res) => setTimeout(res, 500));

      // Capture the div as a canvas
      const canvas = await html2canvas(qrElement, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: "transparent",
        scale: 2, // Higher scale for better quality
        logging: true,
      });

      // Convert canvas to a blob
      const dataUrl = canvas.toDataURL("image/png");
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      const file = new File([blob], "qrcode.png", { type: "image/png" });

      // Use Web Share API to share the QR code image
      if (
        navigator.share &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        await navigator.share({
          title: "Share QR Code",
          text: "Check out my custom QR code!",
          files: [file],
        });
      } else {
        // Fallback: Download the QR code
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "qrcode.png";
        link.click();
      }
    } catch (err) {
      console.error("Error sharing QR code:", err);
      setCopySuccess("Failed to share QR code");
      setTimeout(() => setCopySuccess(""), 2000);
    }
  };

  const stylesUpdLogo = {
    container: {
      maxWidth: "450px",
      margin: "0 auto",
      borderRadius: "8px",
    },

    uploadWrapper: {
      position: "relative",
    },
    uploadArea: {
      border: "2px dashed #d1d5db",
      borderRadius: "8px",
      padding: "10px 15px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      backgroundColor: "#ffffff",
    },
    uploadAreaSuccess: {
      borderColor: "#86efac",
      backgroundColor: "#f0fdf4",
    },
    hiddenInput: {
      display: "none",
    },
    uploadContent: {
      marginTop: "23px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    imageContainer: {
      position: "relative",
    },
    uploadedImage: {
      width: "64px",
      height: "64px",
      objectFit: "contain",
      borderRadius: "4px",
    },
    removeButton: {
      position: "absolute",
      top: "-8px",
      right: "-8px",
      backgroundColor: "#ef4444",
      color: "white",
      border: "none",
      borderRadius: "50%",
      padding: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color 0.2s ease",
    },
    uploadIcon: {
      color: "#3b82f6",
    },
    textContainer: {
      textAlign: "center",
    },
    primaryText: {
      color: "#4b5563",
      fontWeight: "500",
      margin: "0 0 2px 0",
    },
    secondaryText: {
      fontSize: "10px",
      color: "#9ca3af",
      margin: "0",
    },
    progressContainer: {
      width: "100%",
      marginTop: "1px",
      marginBottom: "10px",
    },
    progressHeader: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      color: "#4b5563",
      marginBottom: "4px",
    },
    fileName: {
      fontWeight: "500",
    },
    percentage: {
      fontWeight: "500",
    },
    progressBarBg: {
      width: "100%",
      backgroundColor: "#e5e7eb",
      borderRadius: "9999px",
      height: "8px",
    },
    progressBar: {
      backgroundColor: "#3b82f6",
      height: "8px",
      borderRadius: "9999px",
      transition: "width 0.2s ease",
    },
    errorMessage: {
      marginTop: "12px",
      color: "#ef4444",
      fontSize: "14px",
      fontWeight: "500",
    },
  };

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <div
        className="tell_aboutSection custum_qr_width_step_6"
        style={{ height: "calc(100vh - 220px)", overflow: "hidden" }}
      >
        <div
          className="bussiness_typeCard padingNone"
          style={{ position: "relative" }}
        >
          <div className="step7Div">
            <div>
              <div className="row">
                <div className="col-lg-8 qr_manage_height_clss">
                  <div className="customizer-panel">
                    <div className="scnPageLvl"></div>
                    <div className="d-flex gap-2 align-items-center h3HeadScanPage">
                      {error && (
                        <span style={{ color: "red" }} className="margin_errr">
                          (Please Fill all fields)
                        </span>
                      )}
                    </div>
                    <div className="mobilePreviewContainer">
                      <button
                        type="button"
                        className="mobilePreviews"
                        onClick={handlePreviewMobile}
                      >
                        <Eye size={16} />
                      </button>{" "}
                      <p>Preview</p>
                    </div>

                    <div className="row justi_center_clss">
                      <div className="row mb-xl-3 mb-lg-3">
                        <div className="col-md-4">
                          {/* <div className="form-group">
                            <label>Upload Logo</label>
                            {!isLogoRemoved && (
                              <div className="uploaded_bussiness_logo">
                                <img
                                  src={logo}
                                  className="uploaded_lofo UpLogoWidth"
                                  alt="Uploaded Logo"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = brand_logo;
                                  }}
                                />
                                <img
                                  src={remove_uploaded_image}
                                  className="Remove_uploaded_icon"
                                  alt="Remove"
                                  onClick={handleRemoveLogo}
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            )}

                            {isLogoRemoved && (
                              <>
                                <div
                                  className={`upload-area mb-3`}
                                  onDragOver={handleDragOver}
                                  onDragLeave={handleDragLeave}
                                  onDrop={handleDrop}
                                  onClick={() =>
                                    leftFileInputRef.current.click()
                                  }
                                >
                                  <input
                                    type="file"
                                    ref={leftFileInputRef}
                                    onChange={handleLogoUpload}
                                    accept="image/*"
                                    style={{ display: "none" }}
                                  />

                                  <div className="upload-placeholder">
                                    <i className="upload-icon">📁</i>
                                    <p>
                                      Drop your logo here or browse files. PNG,
                                      JPG or SVG (Max. 2MB)
                                    </p>
                                  </div>
                                </div>
                                {logoError && (
                                  <span
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Please upload a logo
                                  </span>
                                )}
                              </>
                            )}
                          </div> */}
                          <div className="form-group">
                            <label>Upload Logo</label>
                            <div style={stylesUpdLogo.container}>
                              <div style={stylesUpdLogo.uploadWrapper}>
                                {/* Upload Area - Always Visible */}
                                <div
                                  style={{
                                    ...stylesUpdLogo.uploadArea,
                                    ...(logo
                                      ? stylesUpdLogo.uploadAreaSuccess
                                      : {}),
                                  }}
                                  className="upload-area"
                                  onDragOver={handleDragOver}
                                  onDragLeave={handleDragLeave}
                                  onDrop={handleDrop}
                                  onClick={() => fileInputRef.current?.click()}
                                >
                                  {/* Progress Bar */}
                                  {isUploading && (
                                    <div
                                      style={stylesUpdLogo.progressContainer}
                                    >
                                      <div style={stylesUpdLogo.progressHeader}>
                                        <span style={stylesUpdLogo.fileName}>
                                          {image?.name}
                                        </span>
                                        <span style={stylesUpdLogo.percentage}>
                                          {uploadProgress}%
                                        </span>
                                      </div>
                                      <div style={stylesUpdLogo.progressBarBg}>
                                        <div
                                          style={{
                                            ...stylesUpdLogo.progressBar,
                                            width: `${uploadProgress}%`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  )}
                                  {/* File Input */}
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleLogoUpload}
                                    accept="image/png,image/jpg,image/jpeg,image/svg+xml"
                                    style={stylesUpdLogo.hiddenInput}
                                  />

                                  {/* Upload Icon and Text */}
                                  <div style={stylesUpdLogo.uploadContent}>
                                    {logo ? (
                                      <div style={stylesUpdLogo.imageContainer}>
                                        <img
                                          src={logo}
                                          alt="Uploaded logo"
                                          style={stylesUpdLogo.uploadedImage}
                                        />
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveLogo();
                                          }}
                                          style={stylesUpdLogo.removeButton}
                                        >
                                          <X size={12} />
                                        </button>
                                      </div>
                                    ) : (
                                      <div style={stylesUpdLogo.uploadIcon}>
                                        <Upload size={32} />
                                      </div>
                                    )}

                                    <div style={stylesUpdLogo.textContainer}>
                                      <p style={stylesUpdLogo.primaryText}>
                                        {logo
                                          ? "Logo uploaded successfully!"
                                          : "📁 Drop your logo here or browse files"}
                                      </p>
                                      <p style={stylesUpdLogo.secondaryText}>
                                        PNG, JPG or SVG (Max. 2MB)
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="qr_buss_tag_div">
                            <div className="form-group">
                              <div className="w-100 d-flex justify-content-between align-items-center">
                                {" "}
                                <label>Business Name</label>{" "}
                                <div
                                  style={{
                                    color:
                                      bussinesText.replace(/\s/g, "").length >=
                                      25
                                        ? "red"
                                        : "green",
                                    fontSize: "12px",
                                    marginRight: "3px",
                                  }}
                                >
                                  {bussinesText.replace(/\s/g, "").length} / 25
                                </div>
                              </div>

                              <input
                                type="text"
                                className={`form-control ${
                                  shakeBusiness ? "shake" : ""
                                }`}
                                placeholder="Enter Business Name"
                                value={bussinesText}
                                onChange={(e) => {
                                  let inputValue = e.target.value;
                                  const nonSpaceChars = inputValue.replace(
                                    /\s/g,
                                    "",
                                  );
                                  if (nonSpaceChars.length <= 25) {
                                    if (inputValue.length > 0) {
                                      inputValue =
                                        inputValue.charAt(0).toUpperCase() +
                                        inputValue.slice(1);
                                    }
                                    setbussinesText(inputValue);
                                    setBusinessNameError(false);
                                  } else {
                                    setShakeBusiness(true);
                                    setTimeout(
                                      () => setShakeBusiness(false),
                                      500,
                                    );
                                  }
                                }}
                              />

                              {businessNameError && (
                                <span className="text-danger">
                                  Please Enter Business Name
                                </span>
                              )}
                            </div>

                            <div className="form-group">
                              <div className="w-100 d-flex justify-content-between align-items-center">
                                <label>Tagline</label>
                                <div
                                  style={{
                                    color:
                                      (tagLine?.replace(/\s/g, "").length ??
                                        0) >= 35
                                        ? "red"
                                        : "green",
                                    fontSize: "12px",
                                    marginRight: "3px",
                                  }}
                                >
                                  {tagLine?.replace(/\s/g, "").length ?? 0} / 35
                                </div>
                              </div>

                              <input
                                type="text"
                                className={`form-control ${
                                  shakeTagline ? "shake" : ""
                                }`}
                                placeholder="Enter Tagline"
                                value={tagLine ?? ""}
                                onChange={(e) => {
                                  let inputValue = e.target.value;
                                  const nonSpaceChars = (
                                    inputValue ?? ""
                                  ).replace(/\s/g, "");
                                  if (nonSpaceChars.length <= 35) {
                                    if (inputValue.length > 0) {
                                      inputValue =
                                        inputValue.charAt(0).toUpperCase() +
                                        inputValue.slice(1);
                                    }
                                    settagLine(inputValue);
                                    setTaglineError(false);
                                  } else {
                                    setShakeTagline(true);
                                    setTimeout(
                                      () => setShakeTagline(false),
                                      500,
                                    );
                                  }
                                }}
                              />

                              {taglineError && (
                                <span className="text-danger">
                                  Please Enter Tagline
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-xl-3 mb-lg-3">
                        <div className="col-xl-6 col-lg-7 col-md-6  col-sm-7">
                          <div className="form-group">
                            <label>Brand Color</label>
                            <div className="brand_color_semple">
                              <div
                                className="circles_color orenge"
                                style={{ backgroundColor: "#FFA500" }}
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 255,
                                    g: 165,
                                    b: 0,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color purple"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 91,
                                    g: 60,
                                    b: 213,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color red"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 198,
                                    g: 33,
                                    b: 33,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color green"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 34,
                                    g: 197,
                                    b: 94,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color yellow"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 234,
                                    g: 179,
                                    b: 8,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color lightOrenge"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 252,
                                    g: 128,
                                    b: 25,
                                    a: 1,
                                  })
                                }
                              />
                              <div
                                className="circles_color lightBlue"
                                onClick={(e) =>
                                  handleColorClick(e, {
                                    r: 117,
                                    g: 167,
                                    b: 249,
                                    a: 1,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-md-5 col-sm-5">
                          {" "}
                          <div className="form-group">
                            <label>Custom</label>
                            <div
                              className="cutm_color_div"
                              style={{ position: "relative" }}
                            >
                              <div
                                className="custum_color_circle"
                                style={{
                                  backgroundColor: `rgba(${color.r},${color.g},${color.b},${color.a})`,
                                }}
                                onClick={() => setShowPicker((prev) => !prev)}
                              ></div>

                              <div className="hexColorDIv">
                                {rgbaToHex(color).toUpperCase()}
                              </div>

                              {showPicker && (
                                <div
                                  ref={pickerRef}
                                  style={{
                                    position: "absolute",
                                    top: "50px",
                                    zIndex: 100,
                                  }}
                                >
                                  <ChromePicker
                                    color={color}
                                    onChange={(updatedColor) => {
                                      const { r, g, b, a } = updatedColor.rgb;
                                      const selectedColor = {
                                        r: r,
                                        g: g,
                                        b: b,
                                        a: a ?? 1,
                                      };
                                      handleColorClick1(selectedColor);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row mb-3">
                        <div className="col-xl-6 col-lg-7 col-sm-6">
                          <label>QR Pattern Style</label>
                          <div className="QrPatternrow">
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern1 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern1)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern1
                                    ? "1px solid #0e71fa"
                                    : "none",
                              }}
                            >
                              <img src={pattern1} alt="Pattern 1" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern2 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern2)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern2
                                    ? "1px solid #0e71fa"
                                    : "none",
                              }}
                            >
                              <img src={pattern2} alt="Pattern 2" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern3 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern3)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern3
                                    ? "1px solid #0e71fa"
                                    : "none",
                              }}
                            >
                              <img src={pattern3} alt="Pattern 3" width="114" />
                            </div>
                            <div
                              className={`optionBox ${
                                selectedPattern === pattern4 ? "selected" : ""
                              }`}
                              onClick={() => handlePatternSelect(pattern4)}
                              style={{
                                cursor: "pointer",
                                border:
                                  selectedPattern === pattern4
                                    ? "1px solid #0e71fa"
                                    : "none",
                              }}
                            >
                              <img src={pattern4} alt="Pattern 4" width="114" />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-5">
                          <label>QR Frame Style</label>
                          <div className="QrPatternrow">
                            <div
                              className={
                                selectedFrame === "frameBox1" ? "selected" : ""
                              }
                              onClick={() => handleFrameSelect("frameBox1")}
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox1"
                                    ? "1px solid #0e71fa"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox1"></div>
                              <div className="frameLabel">No Frame</div>
                            </div>
                            <div
                              className={
                                selectedFrame === "frameBox" ? "selected" : ""
                              }
                              onClick={() => handleFrameSelect("frameBox")}
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox"
                                    ? "1px solid #0e71fa"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox"></div>
                              <div className="frameLabel">Rounded</div>
                            </div>
                            <div
                              className={
                                selectedFrame === "frameBox circularFrame"
                                  ? "selected"
                                  : ""
                              }
                              onClick={() =>
                                handleFrameSelect("frameBox circularFrame")
                              }
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                border:
                                  selectedFrame === "frameBox circularFrame"
                                    ? "1px solid #0e71fa"
                                    : "none",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="frameBox circularFrame"></div>
                              <div className="frameLabel">Circular</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="actionBTns d-flex gap-2">
                    <button className="save-button" onClick={handleSave}>
                      Save
                    </button>
                    <button
                      className="save-button"
                      onClick={() => {
                        setshareModal(true);
                      }}
                    >
                      Share
                    </button>
                    <button
                      className="download-button"
                      onClick={() => {
                        // handleDownload("png");
                        handleDownloadNew();
                      }}
                    >
                      Download & Print
                    </button>
                  </div>
                </div>

                <div className="col-lg-4 HiddenClss" id="qrScreenMobilePrint1">
                  <div
                    className="qr_container Step_6_QR_container"
                    // style={{ width: "400px", height: "600px" }}
                    // id="qrScreenMobilePrint"
                  >
                    <div
                      className="qrScreenMobile m-auto"
                      // style={{ width: "400px", height: "600px" }}
                    >
                      <div className="logoSection">
                        <div className="logoCircle">
                          <img
                            src={logo || brand_logo}
                            className="dummyBussinesLogo"
                            title="Bussiness Logo"
                            alt="Logo"
                          />
                        </div>
                        <div className="businessInfo">
                          <h2>{bussinesText}</h2>
                          <p>{tagLine}</p>
                        </div>
                      </div>
                      <div
                        className="feedbackSection"
                        style={{ backgroundColor: bgColor }}
                      >
                        <p
                          style={{
                            color: styles.textColor,
                          }}
                        >
                          Please Provide your valuable
                        </p>
                        <h1
                          style={{
                            color: styles.textColor,
                          }}
                        >
                          Feedback
                        </h1>
                      </div>
                      <div className="qrCodeContainer">
                        <div
                          className={selectedFrame}
                          style={{
                            ...getFrameStyles(),
                            clipPath:
                              selectedFrame === "frameBox circularFrame"
                                ? "circle(50% at center)"
                                : "none",
                          }}
                        >
                          <div
                            ref={qrCodeRef}
                            className="qrCodeScreen"
                            style={{
                              width: "160px",
                              height: "160px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              overflow: "hidden",
                              borderRadius:
                                selectedFrame === "frameBox circularFrame"
                                  ? "50%"
                                  : selectedFrame === "frameBox"
                                    ? "12px"
                                    : "0",
                              clipPath:
                                selectedFrame === "frameBox circularFrame"
                                  ? "circle(50% at center)"
                                  : "none",
                            }}
                          />
                        </div>
                      </div>
                      {!bussinesText?.toLowerCase().includes("chaileela") && (
                        <>
                          <div className="social-icons margin_clssss">
                            {businessTypes2?.map((item, index) => {
                              if (index < 4) {
                                return (
                                  <img
                                    key={index}
                                    src={item?.review_logo_base64 || ""}
                                    alt={item.review_name}
                                    title={item.review_name}
                                  ></img>
                                );
                              }
                            })}
                          </div>
                          <div className="preview-footer">
                            Powered by Your <span>Wowreviews</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{ position: "relative", top: "0", left: "-1000px" }}
                >
                  <div
                    className="qr_container Step_6_QR_container"
                    style={{ width: "400px", height: "600px" }}
                    id="qrScreenMobilePrint"
                  >
                    <div
                      className="qrScreenMobile m-auto"
                      style={{ width: "400px", height: "600px" }}
                    >
                      <div className="logoSection">
                        <div className="logoCircle">
                          <img
                            src={logo || brand_logo}
                            className="dummyBussinesLogo"
                            title="Bussiness Logo"
                            alt="Logo"
                          />
                        </div>
                        <div className="businessInfo">
                          <h2
                            style={{
                              whiteSpace: "pre-wrap",
                              letterSpacing: "2px",
                              wordSpacing: "1px",
                              margin: "0 0 4px 0",
                            }}
                          >
                            {bussinesText}
                          </h2>
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              letterSpacing: "2px",
                              wordSpacing: "2px",
                              margin: 0,
                            }}
                          >
                            {tagLine}
                          </p>
                        </div>
                      </div>
                      <div
                        className="feedbackSection"
                        style={{ backgroundColor: bgColor }}
                      >
                        <p
                          style={{
                            color: styles.textColor,
                            whiteSpace: "pre-wrap",
                            letterSpacing: "2px",
                            wordSpacing: "1px",
                          }}
                        >
                          Please Provide your valuable
                        </p>
                        <h1
                          style={{
                            color: styles.textColor,
                            whiteSpace: "pre-wrap",
                            letterSpacing: "2px",
                            wordSpacing: "2px",
                          }}
                        >
                          Feedback
                        </h1>
                      </div>
                      <div className="qrCodeContainer">
                        <div
                          className={selectedFrame}
                          style={{
                            ...getFrameStyles(),
                            clipPath:
                              selectedFrame === "frameBox circularFrame"
                                ? "circle(50% at center)"
                                : "none",
                          }}
                        >
                          <div
                            ref={qrCodeRef2}
                            className="qrCodeScreen"
                            style={{
                              width: "160px",
                              height: "160px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              overflow: "hidden",
                              borderRadius:
                                selectedFrame === "frameBox circularFrame"
                                  ? "50%"
                                  : selectedFrame === "frameBox"
                                    ? "12px"
                                    : "0",
                              clipPath:
                                selectedFrame === "frameBox circularFrame"
                                  ? "circle(50% at center)"
                                  : "none",
                            }}
                          />
                        </div>
                      </div>
                      {!bussinesText?.toLowerCase().includes("chaileela") && (
                        <>
                          <div className="social-icons margin_clssss">
                            {businessTypes2?.map((item, index) => {
                              if (index < 4) {
                                return (
                                  <img
                                    key={index}
                                    src={item?.review_logo_base64 || ""}
                                    alt={item.review_name}
                                    title={item.review_name}
                                  ></img>
                                );
                              }
                            })}
                          </div>
                          <div
                            className="preview-footer"
                            style={{
                              whiteSpace: "pre-wrap",
                              letterSpacing: "2px",
                              wordSpacing: "2px",
                            }}
                          >
                            Powered by Your <span>Wowreviews</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={handlePreviewMobile}
          centered
          backdrop="static"
        >
          <Modal.Body style={{ position: "relative" }}>
            <X
              size={25}
              onClick={handlePreviewMobile}
              className="close_model_div"
            />

            <div className="step7Div ">
              <div className="col-lg-4">
                <div className="qr_container Step_6_QR_container">
                  <div className="qrScreenMobile m-auto">
                    <div className="logoSection">
                      <div className="logoCircle">
                        <img
                          src={logo || brand_logo}
                          className="dummyBussinesLogo"
                          title="Bussiness Logo"
                          alt="Logo"
                        />
                      </div>
                      <div className="businessInfo">
                        <h2>{bussinesText}</h2>
                        <p>{tagLine}</p>
                      </div>
                    </div>
                    <div
                      className="feedbackSection"
                      style={{ backgroundColor: bgColor }}
                    >
                      <p style={{ color: styles.textColor }}>
                        Please Provide your valuable
                      </p>
                      <h1 style={{ color: styles.textColor }}>Feedback</h1>
                    </div>
                    <div className="qrCodeContainer">
                      <div
                        className={selectedFrame}
                        style={{
                          ...getFrameStyles(),
                          clipPath:
                            selectedFrame === "frameBox circularFrame"
                              ? "circle(50% at center)"
                              : "none",
                        }}
                      >
                        <div
                          ref={qrCodeRef}
                          className="qrCodeScreen"
                          style={{
                            width: "160px",
                            height: "160px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            borderRadius:
                              selectedFrame === "frameBox circularFrame"
                                ? "50%"
                                : selectedFrame === "frameBox"
                                  ? "12px"
                                  : "0",
                            clipPath:
                              selectedFrame === "frameBox circularFrame"
                                ? "circle(50% at center)"
                                : "none",
                          }}
                        />
                      </div>
                    </div>
                    {!bussinesText?.toLowerCase().includes("chaileela") && (
                      <>
                        <div className="social-icons">
                          {businessTypes2?.map((item, index) => {
                            if (index < 4) {
                              return (
                                <img
                                  key={index}
                                  src={
                                    item.review_logo_base64 ||
                                    "/placeholder.svg"
                                  }
                                  alt={item.review_name}
                                  title={item.review_name}
                                />
                              );
                            }
                            return null;
                          })}
                        </div>
                        <div className="preview-footer">
                          Powered by Your <span>Wowreviews</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={shareModal}
          onHide={handleShareShowClose}
          centered
          backdrop="static"
          className="share-modal"
          size="md"
        >
          <Modal.Header className="border-bottom">
            <Modal.Title className="h5 mb-0">Share Content</Modal.Title>
            <button
              type="button"
              className="btn-close"
              onClick={handleShareShowClose}
              aria-label="Close"
              style={{
                background: "none",
                border: "none",
                fontSize: "1.2rem",
                cursor: "pointer",
              }}
            >
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body style={{ padding: "30px" }}>
            {/* QR Code Section */}
            <div className="mb-4">
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3"
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="8"
                      height="8"
                      rx="1"
                      fill="#6c757d"
                    />
                    <rect
                      x="13"
                      y="3"
                      width="8"
                      height="8"
                      rx="1"
                      fill="#6c757d"
                    />
                    <rect
                      x="3"
                      y="13"
                      width="8"
                      height="8"
                      rx="1"
                      fill="#6c757d"
                    />
                    <rect x="13" y="13" width="3" height="3" fill="#6c757d" />
                    <rect x="17" y="13" width="4" height="3" fill="#6c757d" />
                    <rect x="13" y="17" width="8" height="4" fill="#6c757d" />
                  </svg>
                </div>
                <div>
                  <h6
                    className="mb-1"
                    style={{ fontWeight: "600", color: "#212529" }}
                  >
                    QR Code
                  </h6>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.9rem" }}>
                    Share QR code for easy review collection
                  </p>
                </div>
              </div>
              <Button
                variant="primary"
                onClick={handleShareQR2}
                className="w-100"
                style={{
                  backgroundColor: "#EC5E3A",
                  padding: "10px 20px",
                  fontWeight: "500",
                  borderRadius: "6px",
                }}
              >
                Share QR Code
              </Button>
            </div>

            <hr className="my-4" style={{ borderColor: "#dee2e6" }} />

            {/* Smart Link Section */}
            <div>
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3"
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.71"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <h6
                    className="mb-1"
                    style={{ fontWeight: "600", color: "#212529" }}
                  >
                    Smart Link
                  </h6>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.9rem" }}>
                    Share via link or copy to clipboard
                  </p>
                </div>
              </div>

              {/* Link Display */}
              <div
                className="mb-3 p-3"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  wordBreak: "break-all",
                  fontSize: "0.9rem",
                  fontFamily: "monospace",
                  color: "#495057",
                }}
              >
                {URLLINK}
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  onClick={handleShareLink}
                  className="flex-fill"
                  style={{
                    backgroundColor: "#EC5E3A",
                    padding: "10px 20px",
                    fontWeight: "500",
                    borderRadius: "6px",
                  }}
                >
                  Share Link
                </Button>

                <Button
                  variant="outline-secondary"
                  onClick={handleCopyLink}
                  className="flex-fill"
                  style={{
                    padding: "10px 20px",
                    fontWeight: "500",
                    borderRadius: "6px",
                  }}
                >
                  Copy Link
                </Button>
              </div>

              {/* Success Message */}
              {copySuccess && (
                <div
                  className="alert alert-success mt-3 mb-0"
                  style={{
                    padding: "10px 15px",
                    fontSize: "0.9rem",
                    borderRadius: "6px",
                  }}
                >
                  <strong>Success!</strong> {copySuccess}
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default QrCodeEdit;
